import TimeParameters from './time-parameters';
import SelectData from './select-data';

import './styles.scss';

export default {
  TimeParameters,
  SelectData
};